



import { Component, Prop, Watch } from 'vue-property-decorator';
import { Mixins } from 'vue-mixin-decorator';

import { PurchaseService } from '@/manager/purchase/purchase.service';

import WithSpinner from '@/shared/mixins/withSpinner.mixin.ts';

@Component({})
export default class PurchaseParticipantTable extends Mixins<WithSpinner> (WithSpinner) {
    @Prop() private oddRow!: boolean;
    @Prop() private purchaseId!: string;

    private participantList: any[] = [];

    private created() {
        this.initial();
    }


    private async initial() {
        this.participantList = await PurchaseService.fetchPurchaseParticipantList(this.purchaseId);
    }
}
